import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/presentation/SimplePresentationRunner";
import {gsap, TimelineLite} from "gsap";
import {HOTB} from "../../HOTB";
import {HOTBData} from "../../server/HOTBData";
import {GameSymbol, SymbolsList, SymbolStates} from "../../reels/GameSymbol";
import {ISymbol} from "../../../core/reel/IReelData";
import {GameSounds} from "../../sound/GameSounds";

export class SideReelFeaturePresentation implements SimplePresentation {
    private _mainTl: TimelineLite;

    public shouldRun(): boolean {
        let flag: boolean = false;

        const hotbData: HOTBData = HOTB.model.data;

        if (hotbData.mode.includes("AVALANCHE")) {
            const prevSpinReels: string[][] = hotbData.symbolsAfterAvalanchePrevSpin;

            flag = prevSpinReels.some(row => row.includes(SymbolsList.LAUNCH));
        }

        return flag;
    }

    public start(controller: SimplePresentationRunnerController): void {
        const leftFeatures: number[] = HOTB.leftReel.checkFeatureTypesPresent(),
            rightFeatures: number[] = HOTB.rightReel.checkFeatureTypesPresent(),
            activeFeatureDelay: number[] = [0, 0];
        if (leftFeatures[0] > 0 || rightFeatures[0] > 0) {
            activeFeatureDelay[0] = 0.9333;
        }
        if (leftFeatures[1] > 0 || rightFeatures[1] > 0) {
            activeFeatureDelay[1] = 0.9333;
        }

        this._mainTl = new TimelineLite({
            delay: 0.2,
            onComplete: (): void => {
                this._mainTl.kill();
                controller.finish();
            }
        });

        this._mainTl.add((): void => {
            controller.setSkipCallback((): void => {
                this.onSkip();
            });
        }, 0.001);

        this._mainTl.add(this.triggerLaunch());

        this._mainTl.add([
            HOTB.leftReel.activateReel(activeFeatureDelay),
            HOTB.rightReel.activateReel(activeFeatureDelay)
        ]);

        this._mainTl.add(() => HOTB.soundPlayer.reset());
    }

    private triggerLaunch(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            hotbData: HOTBData = HOTB.model.data,
            symbolsData: string[][] = hotbData.symbolsAfterAvalanchePrevSpin;

        for (let reelId: number = 0; reelId < symbolsData.length; reelId++) {
            const currReel: string[] = symbolsData[reelId];

            for (let symId: number = 0; symId < currReel.length; symId++) {
                const currSymName: string = currReel[symId];

                if (currSymName === SymbolsList.LAUNCH) {
                    const launchSym: ISymbol = HOTB.reelArea.getSymbolAtPosition(reelId, symId);

                    tl.add([
                        (<GameSymbol>launchSym).getStateAnimation(SymbolStates.TRIGGER),
                        HOTB.leftReel.startRaysAnimation(),
                        HOTB.rightReel.startRaysAnimation(),
                        (): void => {
                            HOTB.soundPlayer.playSound(GameSounds.LAUNCH_TO_WILD);
                        }
                    ], 0);

                    // #312 delay used to avoid jerk issue
                    tl.add(HOTB.reelArea.mainReelModels[reelId].reelView.replaceSymbol(reelId, symId, SymbolsList.WILD));
                }
            }
        }

        return tl;
    }

    private onSkip(): void {
        // this._mainTl.timeScale(5);
        this._mainTl.progress(1);
        HOTB.soundPlayer.stopSideReelFeatureSounds();
    }
}